import { Navigate, useLocation } from 'react-router-dom';

/**
 * Forward /contact (and any ?plan=... query) to the landing CTA section.
 *
 * The previous implementation was a static `<Navigate to="/#cta" />` which
 * dropped query params, so leads sent from PricingPage's annual / enterprise
 * CTAs landed on /#cta with no record of which plan they had selected.
 */
export function ContactRedirect() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/', search, hash: 'cta' }} replace />;
}
